import { unsupported } from "@thi.ng/errors";
/**
 * Specialized / optimized version of `@thi.ng/defmulti` for vector
 * operations. Uses simplified logic to dispatch on length (vector size)
 * of `dispatch` argument.
 *
 * @param dispatch arg index
 */

export var vop = function vop() {
  var dispatch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var impls = new Array(5);
  var fallback;

  var fn = function fn() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var g = impls[args[dispatch].length] || fallback;
    return g ? g.apply(void 0, args) : unsupported("no impl for vec size ".concat(args[dispatch].length));
  };

  fn.add = function (dim, fn) {
    return impls[dim] = fn;
  };

  fn["default"] = function (fn) {
    return fallback = fn;
  }; // fn.impls = impls;


  return fn;
};